import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { tokens, Button } from '@hotjar/hotsauce';

const lockedStyle = css`
  &,
  &:hover,
  &:focus,
  &:active,
  &.active,
  &:active,
  &.active {
    color: ${tokens.color.text_disabled};
  }
`;

export const StyledMenuButton = styled(Button)<{ isLocked: boolean }>`
  ${tokens.text('caption')}
  ${({ isLocked }) => isLocked && lockedStyle}
  filter: grayscale(100%);
  &[disabled] {
    background-color: transparent;
  }
`;
